import { safeLocalStorage } from "../../../../../../utils";
import { DEAL_KPI_OPTIONS, DEFAULT_SELECTED_DEAL_KPI_KEYS, MAX_SELECTED_DEAL_KPIS } from "../constants";
import { DealKpiKey, DealKpiPreference } from "../models";

const validDealKpiKeys = new Set<DealKpiKey>(DEAL_KPI_OPTIONS.map((option) => option.key));

const isDealKpiKey = (value: unknown): value is DealKpiKey =>
  typeof value === "string" && validDealKpiKeys.has(value as DealKpiKey);

export const normaliseDealKpiKeys = (kpiKeys: unknown): DealKpiKey[] => {
  if (!Array.isArray(kpiKeys)) {
    return DEFAULT_SELECTED_DEAL_KPI_KEYS;
  }

  const selectedKpiKeys = kpiKeys.reduce<DealKpiKey[]>((acc, kpiKey) => {
    if (isDealKpiKey(kpiKey) && !acc.includes(kpiKey)) {
      acc.push(kpiKey);
    }
    return acc;
  }, []);

  if (selectedKpiKeys.length === 0) {
    return DEFAULT_SELECTED_DEAL_KPI_KEYS;
  }

  return selectedKpiKeys.slice(0, MAX_SELECTED_DEAL_KPIS);
};

export const parseDealKpiPreference = (storedPreference: string | null): DealKpiKey[] => {
  if (!storedPreference) {
    return DEFAULT_SELECTED_DEAL_KPI_KEYS;
  }

  try {
    const parsedPreference = JSON.parse(storedPreference) as Partial<DealKpiPreference>;
    return normaliseDealKpiKeys(parsedPreference.selectedKpiKeys);
  } catch {
    return DEFAULT_SELECTED_DEAL_KPI_KEYS;
  }
};

export const getStoredDealKpiKeys = (localStorageKey: string): DealKpiKey[] =>
  parseDealKpiPreference(safeLocalStorage.getItem(localStorageKey));

export const saveDealKpiKeys = (localStorageKey: string, selectedKpiKeys: DealKpiKey[]): void => {
  const preference: DealKpiPreference = {
    selectedKpiKeys: normaliseDealKpiKeys(selectedKpiKeys),
  };

  safeLocalStorage.setItem(localStorageKey, JSON.stringify(preference));
};
